import "./InsertBtn.css"
function InsertBtn(props) {



    return <div className="Inbtn" onClick={props.action}>{props.AddText}</div>
}

export default InsertBtn